import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import EditOrganMenuModal from "../modal/EditOrganMenuModal";
import { Material } from "@babylonjs/core";
import CryptoJS from "crypto-js";

function PreviewModel() {
  const [progress, setProgress] = useState(0);
  const { level1 } = useParams();
  const [hasModelDetail, setHasModelDetail] = useState(false);
  const buttonsRef = useRef(null);
  const [hasMaterials, setHasMaterials] = useState(false);
  const [editedOrganMenu, setEditedOrganMenu] = useState(false);
  const menuWrapperRef = useRef(null);
  const [orderedMaterials, setOrderedMaterials] = useState([]);
  const [showEditOrganModal, setShowEditOrganModal] = useState({
    show: false, // initial values set to false and null
    id: null,
  });
  const {
    avatar,
    signout,
    firstName: authFirstName,
    lastName: authLastName,
  } = useAuth();

  const [showProgress, setShowProgress] = useState(false);
  const modelRef = useRef(null);
  const navigate = useNavigate();
  const [presignedUrl, setPresignedUrl] = useState("");
  const { user } = useAuth();
  const [gender, setGender] = useState("Male Abdomen and Pelvis");
  const [genderGlbModelName, setGenderGlbModelName] = useState("male-abdomen-and-pelvis");
  const [showModel, setShowModel] = useState(true);
  const { pathname } = useLocation();

  const model = pathname.split("/").pop();
  const MODEL_DECRYPT_KEY = process.env.REACT_APP_MODEL_DECRYPT_KEY;

  async function decryptArrayBuffer(buffer) {

  const wordArray = CryptoJS.lib.WordArray.create(new Uint8Array(buffer));

  const iv = CryptoJS.lib.WordArray.create(
    wordArray.words.slice(0, 4)
  );

  const encrypted = CryptoJS.lib.WordArray.create(
    wordArray.words.slice(4)
  );

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: encrypted },
    CryptoJS.enc.Utf8.parse(MODEL_DECRYPT_KEY),
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  const typedArray = new Uint8Array(decrypted.sigBytes);

  for (let i = 0; i < decrypted.sigBytes; i++) {
    typedArray[i] =
      (decrypted.words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
  }

  return typedArray.buffer;
}
async function loadModelEnc(modelName) {

  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/model/${modelName}`
  );

  const { url } = await res.json();

  const encryptedBuffer = await fetch(url).then(r => r.arrayBuffer());

  const decryptedBuffer = await decryptArrayBuffer(encryptedBuffer);

  const blob = new Blob([decryptedBuffer], { type: "model/gltf-binary" });

  const blobUrl = URL.createObjectURL(blob);

  setPresignedUrl(blobUrl);
}

async function loadModel(filename) {

  const cache = await caches.open("models-v1");

  // 1️⃣ Check cache first
  const cached = await cache.match(filename);

  if (cached) {
    setShowProgress(true);
    setProgress(0);
    console.log("✅ Loaded model from cache");

    const blob = await cached.blob();

    setProgress(1);

    return URL.createObjectURL(blob);
  }

  console.log("⬇ Downloading model...");

  setShowProgress(true);
  setProgress(0);

  // 2️⃣ Get metadata
  const metaRes = await fetch(
    `${process.env.REACT_APP_API_URL}/model-meta/${filename}`
  );

  if (!metaRes.ok) {
    throw new Error("Failed to get model metadata");
  }

  const { size } = await metaRes.json();

  const chunkSize = 4 * 1024 * 1024; // 4MB
  const maxParallel = 4;

  const totalChunks = Math.ceil(size / chunkSize);
  const chunks = new Array(totalChunks);

  let index = 0;
  let downloaded = 0;

  async function worker() {

    while (true) {

      const current = index++;

      if (current >= totalChunks) break;

      const start = current * chunkSize;
      const end = Math.min(start + chunkSize - 1, size - 1);

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/model-chunk/${filename}?start=${start}&end=${end}`
      );

      if (!res.ok) {
        throw new Error(`Chunk ${current} failed (${res.status})`);
      }

      const buffer = await res.arrayBuffer();

      chunks[current] = buffer;

      downloaded += buffer.byteLength;

      setProgress(downloaded / size);
    }
  }

  await Promise.all(
    Array.from({ length: maxParallel }, () => worker())
  );

  const blob = new Blob(chunks, {
    type: "model/gltf-binary"
  });

  // 3️⃣ Save complete GLB into browser cache
  await cache.put(
    filename,
    new Response(blob, {
      headers: {
        "Content-Type": "model/gltf-binary"
      }
    })
  );

  console.log("✅ Model cached");

  return URL.createObjectURL(blob);
}

async function loadModel1(filename) {
  setShowProgress(true);
  setProgress(0);

  const metaRes = await fetch(
    `${process.env.REACT_APP_API_URL}/model-meta/${filename}`
  );

  if (!metaRes.ok) {
    throw new Error("Failed to fetch model metadata");
  }

  const { size } = await metaRes.json();

  const chunkSize = 4 * 1024 * 1024; // 4 MB
  const maxParallel = 4;

  const totalChunks = Math.ceil(size / chunkSize);
  const chunks = new Array(totalChunks);

  let index = 0;
  let downloadedBytes = 0;

  async function worker() {
    while (true) {
      const current = index++;

      if (current >= totalChunks) {
        break;
      }

      const start = current * chunkSize;
      const end = Math.min(start + chunkSize - 1, size - 1);

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/model-chunk/${filename}?start=${start}&end=${end}`
      );

      if (!res.ok) {
        throw new Error(`Failed to download chunk ${current}`);
      }

      const buffer = await res.arrayBuffer();

      chunks[current] = buffer;

      downloadedBytes += buffer.byteLength;

      // Never allow progress to decrease
      setProgress(prev => {
        const next = downloadedBytes / size;
        return Math.max(prev, next);
      });
    }
  }

  const workers = Array.from(
    { length: maxParallel },
    () => worker()
  );

  await Promise.all(workers);

  // Ensure progress reaches 100%
  setProgress(1);

  const blob = new Blob(chunks, {
    type: "model/gltf-binary",
  });
  return URL.createObjectURL(blob);
}

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!buttonsRef.current || !menuWrapperRef.current) return;
      if (!menuWrapperRef.current.contains(e.target)) {
        buttonsRef.current.classList.remove("open");
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);


  const refreshOrganMenuWithMaterials = async (updatedMaterials) => {
    const modelMaterials = modelRef.current.model.materials;
    const orderedModelMaterials = manageMaterialFromModelAndDB(
      modelMaterials,
      updatedMaterials
    );

    // console.log("refreshOrganMenuWithMaterials modelMaterials", modelMaterials);
    // console.log("refreshOrganMenuWithMaterials orderedModelMaterials", orderedModelMaterials);
    // console.log("refreshOrganMenuWithMaterials orderedModelMaterials", orderedModelMaterials);

    if (!orderedModelMaterials.length) return;
    // ✅ wait for model detail to refresh
    // await fetchModelDetail();
    setEditedOrganMenu(orderedModelMaterials);
    loadOrganMenuFromDB(orderedModelMaterials);
  };

  async function updateMaterialsIfMissing(modelDetail, materials) {
    if (!materials?.length) return;
    if (!modelDetail) modelDetail = await fetchModelDetail();

    if (modelDetail.materials.length <= 0) {
      const materialConfig = materials.map((m, order) => ({
        originalName: m.name,
        displayName: m.name,
        order,
      }));

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/update-glb-model-material`,
          { _id: modelDetail.id, materials: materialConfig }
        );

        const orderedModelMaterials = manageMaterialFromModelAndDB(
          materials,
          response.data.materials
        );

        setEditedOrganMenu(orderedModelMaterials);
        setOrderedMaterials(orderedModelMaterials);
      } catch (err) {
        console.error("Failed to update materials:", err);
      }
    }
  }

  function manageMaterialFromModelAndDB(modelMaterials, dbMaterials) {
    if (!Array.isArray(modelMaterials) || !Array.isArray(dbMaterials)) return [];

    const modelMaterialMap = {};
    modelMaterials.forEach((mat) => (modelMaterialMap[mat.name] = mat));

    return [...dbMaterials]
      .sort((a, b) => a.order - b.order)
      .map((dbMat) => {
        const modelMat = modelMaterialMap[dbMat.originalName];
        if (!modelMat) return null;

        modelMat.displayName = dbMat.displayName;
        modelMat.originalName = dbMat.originalName;
        modelMat.order = dbMat.order;
        modelMat.visible = modelMat.visible ?? true;

        return modelMat;
      })
      .filter(Boolean);
  }

  function loadOrganMenuFromDB(materials) {
    if (!materials?.length) return;
    if (!buttonsRef.current) return;

    buttonsRef.current.innerHTML = "";

    materials.forEach((mat, index) => {
      let labelText = mat.displayName || `Material ${index}`;
      let visible = true;

      if (!mat._originalBaseColor && mat.pbrMetallicRoughness) {
        const base = mat.pbrMetallicRoughness.baseColorFactor || [1, 1, 1, 1];
        mat._originalBaseColor = [...base];
      }

      const row = document.createElement("div");
      row.className = "d-flex align-items-center justify-content-between w-100 py-2";

      const label = document.createElement("span");
      label.className = "text-green1 fw-bold menu-span-lable";
      label.textContent = labelText;

      const right = document.createElement("div");
      right.className = "d-flex align-items-center gap-2 pointer";

      const toggleImg = document.createElement("img");
      toggleImg.src = "/images/show-toggle.png";
      toggleImg.style.width = "3.5rem";

      right.appendChild(toggleImg);

      right.onclick = () => {
        visible = !visible;
        if(mat.originalName === "adskMatPeritonum"){
          mat.setAlphaMode("BLEND");
          mat.transparencyMode = Material.MATERIAL_ALPHABLEND;
          mat.alpha = 0.4;
        }else{
          mat.setAlphaMode("MASK");
          mat.setAlphaCutoff(0.5);
        }

        const [r, g, b, a] = mat._originalBaseColor;
        mat.pbrMetallicRoughness?.setBaseColorFactor([r, g, b, visible ? a : 0]);

        toggleImg.src = visible
          ? "/images/show-toggle.png"
          : "/images/hidetoggleicon.png";
      };

      row.appendChild(label);
      row.appendChild(right);
      buttonsRef.current.appendChild(row);
    });

    buttonsRef.current.classList.remove("open");

    const toggleBtn = document.getElementById("variantToggleBtn");
    if (toggleBtn) {
      toggleBtn.onclick = (e) => {
        e.stopPropagation();
        buttonsRef.current.classList.toggle("open");
      };
    }
  }

  const onLoad = (detail) => {
    // setProgress(1);

    // hide loader after model actually renders
    setTimeout(() => {
      setShowProgress(false);
    }, 100);

    const model = modelRef.current;
    if (!model?.model) return;

    const materials = model.model.materials;
    const hasMats = Array.isArray(materials)
      ? materials.length > 0
      : Object.keys(materials || {}).length > 0;

    setHasMaterials(hasMats);
    if (!hasMats) return;

    const dbMaterials = detail?.materials || [];

    if (!dbMaterials.length) {
      updateMaterialsIfMissing(detail, materials);
    }

    const orderedModelMaterials = manageMaterialFromModelAndDB(materials, dbMaterials);
    if (!orderedModelMaterials.length) return;

    setOrderedMaterials(orderedModelMaterials);
  };

  const onProgress = (e) => {
    if (e.detail.totalProgress < 1) {
      setShowProgress(true);
      setProgress(e.detail.totalProgress);
    }
  };

  async function getModelDetail() {
    const payload = {
      level1: level1,
      level2: model  // <-- always correct
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/get-glb-model-detail`,
      payload
    );

    return response.data;
  }

  const fetchModelDetail = async () => {
    try {
      const modelDetail = await getModelDetail();

      // ❌ No data in DB
      if (!modelDetail || !modelDetail.file_name || modelDetail.file_name === "coming-soon") {
        setHasModelDetail(null);
        setShowModel(false);
        setPresignedUrl("");   // important: clear old model
        return null;
      }

      // ✅ Valid model
      setHasModelDetail(modelDetail);
      setShowModel(true);

      if (process.env.NODE_ENV === "development") {
        setPresignedUrl(`/${modelDetail.file_name}`);
        // loadModelEnc("male-abdomen-and-pelvis");
        // const url = await loadModel(modelDetail.file_name);
        // setPresignedUrl(url);
      } else {
        getModelPresignUrl(modelDetail.file_name);
        // loadModelEnc("male-abdomen-and-pelvis");
        // const url = await loadModel("modelDetail.file_name");
        // setPresignedUrl(url);
      }

      return modelDetail;
    } catch (error) {
      console.error("Failed to fetch model detail", error);
      setHasModelDetail(null);
      setShowModel(false);
      setPresignedUrl("");
      return null;
    }
  };

  const getModelPresignUrl = (fileName) => {
    setProgress(0);
    setShowProgress(true);
    modelRef.current?.showPoster();

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/get-upload-model-presign-url`,
        { model_name: fileName },
        { headers: { Authorization: "Bearer " + user.jwtToken } }
      )
      .then((res) => setPresignedUrl(res.data))
      .catch(console.error);
  };

  useEffect(() => {
    if (!level1 || !model) return;

    const init = async () => {
      setShowProgress(true);
      setShowModel(true);
      setPresignedUrl("");

      const detail = await fetchModelDetail();
      if (!detail) {
        setShowModel(false);
        return null;
      }

      const onLoadWithDetail = () => onLoad(detail);

      modelRef.current?.addEventListener("load", onLoadWithDetail);
      // modelRef.current?.addEventListener("progress", onProgress);

      return () => {
        modelRef.current?.removeEventListener("load", onLoadWithDetail);
        // modelRef.current?.removeEventListener("progress", onProgress);
      };
    };

    init();
  }, [level1, model]);

  useEffect(() => {
    if (model === "male-abdomen-and-pelvis") {
      setGender("Male Abdomen and Pelvis");
      setGenderGlbModelName("male-abdomen-and-pelvis");
    }

    if (model === "female-abdomen-and-pelvis") {
      setGender("Female Abdomen and Pelvis");
      setGenderGlbModelName("female-abdomen-and-pelvis");
    }
  }, [model]);


  const handleGenderChange = (modelName) => {
    navigate(`/${level1}/${modelName}`);
  };

  useEffect(() => {
    if (!hasMaterials) return;
    if (!buttonsRef.current) return;
    if (!orderedMaterials.length) return;

    loadOrganMenuFromDB(orderedMaterials);
  }, [hasMaterials, orderedMaterials]);

  function logout() {
    signout(() => navigate("/"));
  }

  const editOrganMenuModelClick = (id) => {
    setShowEditOrganModal({
      show: true,
      id,
    });
  };
  return (
    <>
      {hasModelDetail && (
        <EditOrganMenuModal
          modal={showEditOrganModal.show}
          setModal={setShowEditOrganModal}
          id={hasModelDetail.id}
          materials={editedOrganMenu ? editedOrganMenu : hasModelDetail.materials}
          onMaterialsUpdated={refreshOrganMenuWithMaterials}
        />
      )}
      <div className="w-100 h-100 bg-green5">
        <header>
          <div className="d-flex align-items-center justify-content-between px-4 py-2 main-header">
            <div className="d-flex align-items-center w-75">
              <div className="pe-4">
                <Link to="/dashboard">
                  <img
                    src="/images/Anatomy-unlocked-motif-black.png"
                    alt=""
                    style={{ width: "3rem" }}
                  />
                </Link>
              </div>
              <div className="d-flex flex-column justify-content-center">
                <h3 className="pb-1 pt-2 m-0 fw-bolder text-green1">
                  Functional Anatomy
                </h3>
              </div>
            </div>
            <div className="d-flex align-items-center">
              {/* <button className="btn btn-green1 float-end fw-bold fw-bold me-2" type="button">
                Practice Questions
              </button> */}
              <a className="btn btn-green3 bg-blue1 border-0 px-2 me-2" href="#">
                <img
                  src="/images/menu/torso.png"
                  alt="torso"
                  style={{ width: "1.5rem" }}
                />
              </a>

              <div className="dropdown">
                <div
                  role="button"
                  className="avatar fs-6 fw-bold"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    alt=""
                    src={
                      avatar
                        ? `${process.env.REACT_APP_MEDIA_URL}/avatar/${avatar}`
                        : "/images/avatar.png"
                    }
                    className="rounded-circle border border-2 border-white bg-white img-fluid"
                    style={{ width: "3rem", height: "3rem" }}
                  />
                </div>
                <div
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <ul className="p-1 m-0">
                    <li className="d-flex justify-content-center">
                      <img
                        alt=""
                        src={
                          avatar
                            ? `${process.env.REACT_APP_MEDIA_URL}/avatar/${avatar}`
                            : "/images/avatar.png"
                        }
                        className="rounded-circle border border-2 border-white bg-white img-fluid me-2"
                        style={{ width: "2rem", height: "2rem" }}
                      />
                      <span className="fs-5 fw-bolder">
                        {authFirstName} {authLastName}
                      </span>
                    </li>
                  </ul>
                  <div>
                    <Link
                      to="/my-account"
                      className="dropdown-item fw-bolder fs-6"
                    >
                      <div className="row">
                        <div className="col-3"></div>
                        <div className="col-6">My Account</div>
                        <div className="col-3"></div>
                      </div>
                    </Link>

                    <Link
                      to="/dashboard"
                      className="dropdown-item fw-bolder fs-6"
                    >
                      <div className="row">
                        <div className="col-3"></div>
                        <div className="col-6">Dashboard</div>
                        <div className="col-3"></div>
                      </div>
                    </Link>

                    <span
                      role="button"
                      className="dropdown-item fw-bolder fs-6"
                      onClick={logout}
                    >
                      <div className="row">
                        <div className="col-3"></div>
                        <div className="col-6">Logout</div>
                        <div className="col-3"></div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <main className="main-section mx-4 rounded-top-3 bg-white">
          <div className="h-100">
            <div className="row bg-green4 rounded-top-3 m-0 content-header position-relative">
              <div className="position-absolute d-flex w-auto top-0 start-50 translate-middle-x mt-2 align-items-center justify-content-center text-green1">
                <span className="fw-bold">2.0 Abdomen</span>
              </div>
              <div className="col-12 d-flex d-xl-none content-header-top"></div>
              <div className="col-6 d-flex align-items-center justify-content-start">
                <button
                  className="btn btn-sm btn-link text-decoration-none fw-bold"
                  onClick={() => navigate(-1)}
                >
                  <span className="icon-left"></span> Previous
                </button>
              </div>
              {/* <div className="col-6 d-flex align-items-center justify-content-end dropdown">
                <button
                  className="btn btn-secondary dropdown-toggle fw-bold"
                  type="button"
                  id="dropdownMenuButton2"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {gender}
                </button>

                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="dropdownMenuButton2"
                >
                  <li>
                    <button
                      type="button"
                      className={`dropdown-item fs-7 fw-bolder ${model === "male-abdomen-and-pelvis" ? "active" : ""
                        }`}
                      onClick={() => handleGenderChange("male-abdomen-and-pelvis")}
                    >
                      Male Abdomen and Pelvis
                    </button>
                  </li>

                  <li>
                    <button
                      type="button"
                      className={`dropdown-item fs-7 fw-bolder ${model === "female-abdomen-and-pelvis" ? "active" : ""
                        }`}
                      onClick={() => handleGenderChange("female-abdomen-and-pelvis")}
                    >
                      Female Abdomen and Pelvis
                    </button>
                  </li>
                </ul>
              </div> */}
            </div>
            <div
              className={"height-scroll bg-gray5 overflow-hidden "}
              style={{ position: "relative" }}
            >
              {showModel && (
                <>
                  <div className="d-flex justify-content-between align-items-start w-100 menu-main-div">
                    {/* Overlay menu */}
                    {hasMaterials && (
                      <>
                        <div ref={menuWrapperRef} className="model-overlay-menu row-sm-4" style={{
                          position: "absolute",
                          right: "12px",
                          zIndex: 10
                        }}>
                          <div className="d-flex gap-2">
                            {/* <button
                              className="toggle-btn icon-btn"
                              onClick={() => editOrganMenuModelClick(hasModelDetail.id)}
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button> */}

                            <button
                              id="variantToggleBtn"
                              className="toggle-btn icon-btn"
                            >
                              <span
                                className="material-symbols-outlined"
                                style={{ fontSize: "20px" }}
                              >
                                menu
                              </span>
                            </button>
                          </div>

                          <div
                            id="variantButtons"
                            ref={buttonsRef}
                            className="model-overlay-buttons organ-menu"
                          />
                        </div>
                      </>
                    )}

                  </div>
                  <div className="model-object bg-gray5 h-100 w-100">
                    <div className="w-100 h-100 d-flex">
                      <model-viewer
                        className="model-viewer"
                        camera-orbit="90deg 90deg 105%"
                        src={presignedUrl}
                        environment-image="/images/hdri/neutral.hdr"
                        alt="Liver"
                        camera-controls
                        ref={modelRef}
                        interaction-prompt="none"
                      >
                        <div slot="poster" className="position-relative h-100">
                          <div className="position-absolute top-50 start-50 translate-middle"></div>
                        </div>
                        <div
                          slot="progress-bar"
                          className={
                            "position-relative h-100 " +
                            (showProgress ? "d-block" : "d-none")
                          }
                        >
                          <div className="position-absolute top-50 start-50 translate-middle">
                            <div className="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                            <div className="position-absolute top-50 start-50 translate-middle">
                              <span className="fw-bold text-secondary">
                                {Math.trunc(progress * 100)}%
                              </span>
                            </div>
                          </div>
                        </div>
                      </model-viewer>
                    </div>
                  </div>

                </>
              )}
              <div
                className={`w-100 h-100 bg-green1 position-relative justify-content-center align-items-center ${showModel ? "d-none" : "d-flex"
                  }`}
              >
                <div className="position-absolute z-0 w-100 h-100 coming-soon-bg1"></div>
                <div className="position-absolute z-1 w-100 h-100 coming-soon-bg2"></div>
                <div className="position-absolute z-2 w-100 h-100 d-flex justify-content-center align-items-center">
                  <h1 className="text-white fw-bold">Model Coming Soon</h1>
                </div>
              </div>
            </div>
            <footer className="d-flex justify-content-between px-4 w-100 main-footer bg-green1">
              <div className="d-flex align-items-center">
                <img
                  src="/images/logo/anatomy-unlocked-logo-horizontal-white.svg"
                  alt=""
                  className=""
                />
                <div className="d-flex align-items-center ps-5">
                  <span className="text-white fs-8">Built by</span>
                  <img
                    src="/images/logo/vection-logo-white.svg"
                    style={{ width: "5rem" }}
                    alt=""
                    className="ps-2"
                  />
                </div>
                <Link to="/collaborators" className="ms-5 text-white fs-8">
                  Collaborators
                </Link>
                {user && (
                  <a
                    href={"/instructions.pdf"}
                    className="ms-3 text-white fs-8"
                    target="_blank"
                  >
                    Instructions
                  </a>
                )}
              </div>

              <div className="d-flex align-items-center fs-8 text-white">
                <div className="me-3">
                  <a
                    href="https://www.iubenda.com/privacy-policy/43897133"
                    className="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe text-white"
                    title="Privacy Policy "
                  >
                    Privacy Policy
                  </a>
                </div>
                &copy; Copyright 2023
              </div>
            </footer>
          </div>
        </main>
      </div>
    </>
  );
}

export default PreviewModel;
